// Every page of the site except the front page.
//
// To add a page:
//   1. add an entry here          (shows up in the front-page sidebar)
//   2. add its component in pages.js
//   3. add its rewrite and header in vercel.json
// registry.test.js fails if any of the three disagree.
export const PATHS = [
  { id: 'dnd', path: '/dnd', label: 'D&D tools', blurb: 'NPCs, monsters, spells, dice and more.', icon: '🎲' },
  { id: 'mc', path: '/mc', label: 'Realistic Water & more!', blurb: 'My Minecraft mod.', icon: '⛏️' },
  { id: 'odyssey', path: '/odyssey', label: 'The Odyssey', blurb: 'Links I found around the web.', icon: '🧭' },
  { id: 'voidworld', path: '/void-world', label: 'Void World', blurb: 'A wiki of a world I made up.', icon: '🌌' },
  { id: 'blackmarkedman', path: '/blackmarkedman', label: 'Black Marked Man', blurb: 'The life of a man from a boggy village, in order.', icon: '🌑' },
  { id: 'wwi', path: '/wwi', label: 'WWI', blurb: 'France and Germany at war, Paris to Berlin, every man on the rolls.', icon: '🚩' },
  { id: 'lorraine', path: '/thebattleforlorraine', label: 'The Battle for Lorraine', blurb: 'France and Germany fight over two towns, every soldier seen.', icon: '⚔️' },
  { id: 'gmh', path: '/gmh', label: 'Good Morning Hitler', blurb: 'Wake up in 1933 with a country to steer, and see how it ends.', icon: '🌅' },
  { id: 'talk', path: '/talk', label: 'Conversation with Claude', blurb: 'Talk with me by typing. The words are fixed; the path is yours.', icon: '💬' }

];

// how many buttons the front-page sidebar shows at a time
export const SIDEBAR_COUNT = 5;

// Pages that exist but are not offered in the sidebar (tools for the site owner).
// They still need a component in pages.js and rewrites/headers in vercel.json.
export const HIDDEN_PATHS = [
  { id: 'ytlab', path: '/ytlab' },
  { id: 'battle', path: '/battle' },
  { id: 'underconstruction', path: '/underconstruction' },
  { id: 'rpg', path: '/rpg' },
  { id: 'dienasty', path: '/dienasty' }
];
